import { func, string } from 'prop-types';

export const field = { component: func, name: string, label: string };
